import React from 'react'
import selectn from 'selectn'
import VideoGrid from '../VideoGrid'
import { PlayersToWatch } from '../PlayersToWatch'
import { HeadToHead } from '../HeadToHead'
import { MatchCardSlider } from './MatchCards'
import { ScorecardSummary, MatchNotes, CloseOfPlay, MatchDetails, Coverage, Commentary, CommentaryFeedback, Innings, InningsSummary, SquadTabs, SquadModule, Article, HawkEye, Scorers } from './index'
import { BestPerformers, Statistics } from './Statistics'
import { Charts } from './Charts'
import { Partnerships } from './Partnerships'
import { Ad, BettingOddsModule, StandingsModule, NewsModule, TopStories, Outbrain, TopHighlights } from '../../common'
import { getVideosMore } from '../../../actions/api'
import { setDeviceType } from '../../../actions/utils'
import { getPlayByPlayMore } from '../../../actions/api/cricket'
import { GameBreak } from '../GameBreak'
import { GameHeader } from '../GameHeader'
import { isBet365KioskEdition, deviceType, getMpuIndex } from '../../../lib/utils/common'

/**
 * Generate the Game package view for Cricket
 * @param  {String} options.pageType PageType
 * @param  {Object} options.state    Application state
 * @return {Object}                  Arrays having React components for each column
 */
export const getCricketView  = ({
  pageType = 'game',
  state = {},
  params,
  query
}) => {


  let appView = ''
  let excludeVal = [ 'm','s' ]
  const isCricinfoAsia = selectn('edition.isAsiaRegion', state) || false
  const isEspnCricinfo = selectn('edition.isEspnCricinfo', state) || false
  const editionDomain = selectn('edition.domain', state) || ''
  const bet365Kiosk = isBet365KioskEdition(state.edition)
  const showBet365module = (state.bet365 && (state.bet365.showInEdition && state.bet365.showInGeo)) || false
  const matchFlags = selectn('matchFlags', state)
  const playerOfTheMatch = selectn('matchDetails.playerOfMatch', state)
  const typeOfDevice = selectn('appProps.device', state) || {}
  const { gameStrip = {}, gameStateClassMobile = '', links = [], summary = '', showGameDetailFooter = false, innings = {}, gameState = '', watchESPNLink = {}, isWebView, adblock } = state
  const gameHeaderProps = {
    gameStrip: gameStrip,
    sport: params.sport,
    gameStateClassMobile: gameStateClassMobile,
    links: links,
    pageType: pageType,
    summaryText: summary,
    showGameDetailFooter: showGameDetailFooter,
    innings: innings,
    gameState: gameState,
    matchFlags: matchFlags,
    playerOfTheMatch: playerOfTheMatch,
    watchESPNLink: watchESPNLink,
    isWebView: isWebView,
    device: typeOfDevice
  }
  const gameheader = <GameHeader {...gameHeaderProps} />
  const gameheaderFull = <GameHeader key="ghf" fullWidth={true} {...gameHeaderProps} />
  const highlightsVideoCount = selectn('videoSlider.videos.length', state)

  const mobileAdPlaceholder = [
    <Ad key="gs-ad-m1" id="banner" className="react-ad ad-banner-mobile ad-wrapper" slotType="banner" kvpos="top" include={[ 's' ]} isAdBlock={adblock} />,
    isCricinfoAsia &&
      <Ad key="gs-ad-m2" id="presbymobile" className="react-ad ad-slot-presby ad-wrapper" slotType="presbyMobile" kvpos="top" include={[ 's' ]} isAdBlock={adblock} />
  ]

  let mobileIncontentAd = <Ad key="gs-ad-4" id="mpu" className="ad-slot-independent ad-slot-mobile-incontent ad-wrapper" slotType="incontent" kvpos="top" inView="true" include={[ 's','m' ]} isAdBlock={adblock} />
  if(state.isWebView) {
    mobileIncontentAd = <Ad key="gs-ad-4" id="mpu" className="ad-slot-inview ad-slot-mobile-incontent ad-wrapper" slotType="incontent" kvpos="top" include={[ 's','m' ]} isAdBlock={adblock} />
  }

  let mpuIndex = getMpuIndex(highlightsVideoCount, state.standings, state.matchcards, state.news) || 4

  let nativeAdSlotsAsia = []
  if(isCricinfoAsia) {
    nativeAdSlotsAsia = [
      <Ad key="native2" className="sub-module ad-slot-independent ad-slot-native ad-wrapper" slotType="native2" inView="true" exclude={excludeVal} isAdBlock={adblock} />,
      <Ad key="native3" className="sub-module ad-slot-independent ad-slot-native ad-wrapper" slotType="native3" inView="true" exclude={excludeVal} isAdBlock={adblock} />,
      <Ad key="native4" className="sub-module ad-slot-independent ad-slot-native ad-wrapper" slotType="native4" inView="true" exclude={excludeVal} isAdBlock={adblock} />,
      <Ad key="native5" className="sub-module ad-slot-independent ad-slot-native ad-wrapper" slotType="native5" inView="true" exclude={excludeVal} isAdBlock={adblock} />
    ]
  }
  
  let columnThree = [
    bet365Kiosk &&
    <div key="kiosk-ad" className="sub-module">
      <Ad id="bet365" className="ad-slot-incontent-strip ad-wrapper" slotType="incontentstrip" kvpos="top" exclude={excludeVal} isAdBlock={adblock} />
    </div>,
    isEspnCricinfo && 
    <div key="adinstr" className="sub-module">
      <Ad id="instrip" className="ad-slot-incontent-strip ad-wrapper" slotType="incontentstrip" kvpos="top" exclude={excludeVal} isAdBlock={adblock} />
    </div>,
    <div key="ad" className="sub-module">
      <Ad id="mpu" className="ad-slot-incontent ad-wrapper" slotType="incontent" kvpos="top" exclude={excludeVal} isAdBlock={adblock} />
    </div>,
    isCricinfoAsia &&
    <Ad key="promoad" className="sub-module ad-slot-independent ad-slot-promobox ad-wrapper" slotType="promobox" inView="true" kvpos="top" exclude={excludeVal} isAdBlock={adblock} />,
    <MatchCardSlider key="mc" title="Match Cards" matchcards={state.matchcards} />,
    showBet365module &&
    <BettingOddsModule key="bo" title="BettingOdds" {...state.bet365} edition={state.edition}/>,
    <StandingsModule key="s" title="Cricket Table" {...state.standings} />,
    <Ad key="native1" className="sub-module ad-slot-independent ad-slot-native ad-wrapper" slotType="native1" inView="true" exclude={excludeVal} isAdBlock={adblock} />,
    ...nativeAdSlotsAsia  
  ]

  
  // Hide match top videos module in the 3rd column on video page, and for tablet
  if(pageType !== 'video') {
    typeOfDevice.desktop && highlightsVideoCount && columnThree.splice(3, 0,  <TopHighlights {...state.videoSlider} title="Videos" />)
  }

  // Hide match coverage module in the 3rd column on coverage page
  if(pageType !== 'coverage') {
    let insertIndex = 5
    if (pageType === 'video') {
      insertIndex = 3
    }
    columnThree.splice(insertIndex, 0, <NewsModule key="nm" title="Match Coverage" {...state.news}  />)
  }

  columnThree.splice(mpuIndex, 0, <Ad key="mpu2" className="sub-module ad-slot-independent ad-slot-incontent ad-wrapper" slotType="incontent2" kvpos="bottom" inView="true" exclude={excludeVal} isAdBlock={adblock} />)

  switch(pageType) {
    case 'game':
    case 'match':
      appView = getSummary({ state, columnThree, params, query, isCricinfoAsia, gameheader, mobileAdPlaceholder, editionDomain, mobileIncontentAd })
      break

    case 'scorecard':
      appView = getScorecard({ state, columnThree, isCricinfoAsia, gameheader, mobileAdPlaceholder, mobileIncontentAd })
      break

    case 'commentary':
      appView = getCommentary({ state, columnThree, showFilters: true, params, query, isCricinfoAsia, gameheader, mobileAdPlaceholder, editionDomain, mobileIncontentAd })
      break

    case 'statistics':
      appView = getStatistics({ state, columnThree, isCricinfoAsia, gameheader, mobileAdPlaceholder, mobileIncontentAd })
      break

    case 'video':
      appView = getVideos({ state, columnThree, params, query, gameheader, mobileAdPlaceholder })
      break

    case 'coverage':
      appView = getMatchCoverage({ state, columnThree, gameheader, mobileAdPlaceholder })
      break

    case 'preview':
      appView = getArticleContent({ state, columnThree, gameheader, mobileAdPlaceholder })
      break

    case 'report':
      appView = getArticleContent({ state, columnThree, gameheader, mobileAdPlaceholder })
      break

    case 'hawkeye':
      appView = getHawkEye({ state, columnThree, gameheader, mobileAdPlaceholder })
      break
  }

  return [ gameheaderFull, appView ]
}

const getArticleContent = ({ state, columnThree, gameheader, mobileAdPlaceholder }) => {
  return (
    <div key="a" className="main-content react-content">
      <div id="gamepackage-wrap">
        <div id="gamepackage-content-wrap" className="layout-bc">
          <div className="col-b">
            {gameheader}
            {mobileAdPlaceholder}
            <Article article={state.article} />
          </div>
          {
            !state.isMobile &&
              <section className="col-c">
                {columnThree}
              </section>
          }
        </div>
      </div>
    </div>
  )
}

const getSummary = ({ state, columnThree, params, query, isCricinfoAsia, gameheader, mobileAdPlaceholder, editionDomain, mobileIncontentAd }) => {
  const stateTypeId = parseInt(state.stateTypeId,10)
  const isLimitedOvers = selectn('matchFlags.limitedOvers', state)
  const isUpdatesOnly = selectn('matchFlags.updatesOnly', state)
  const partCommentary = selectn('partCommentary',state) || {}
  const commentPreText = selectn('partCommentary.commentPreText',state) || ''
  const bowlingStarted = (selectn('partCommentary.overs',state) || []).length > 0
  const adblock = selectn('adblock', state) || false

  let isCommentaryAvailable = false
  if(bowlingStarted || commentPreText.length > 0) {
    isCommentaryAvailable = true
  }

  const updatesOnlyComms = isUpdatesOnly && isCommentaryAvailable
  const scoringSourceFeedback = selectn('scoringSource.isFeedback', state)
  const videoSlider = state.videoSlider || {}
  let { articleVideos = [], videos = [], ...videoSliderRest } = videoSlider
  let activePlayer = selectn('innings.activePlayers', state) || []
  const showBet365module = (state.bet365 && (state.bet365.showInEdition && state.bet365.showInGeo)) || false

  let isDesktop = true
  if (process.browser) {
    const device = deviceType() || {}
    isDesktop = device.isDesktop || device.isDesktopXX
  } else {
    isDesktop = selectn('appProps.device.desktop', state)
  }
  let isTablet = selectn('appProps.device.tablet', state) || false
  videos = isDesktop && !isTablet ? articleVideos : videos
  const topStoriesClassName = isDesktop && !isTablet ? 'single-video' : ''
  let groundTime = selectn('partCommentary.groundTime', state)
  let scorer = selectn('partCommentary.scorer', state)
  let commentator = selectn('partCommentary.commentator', state)

  let commsNts = [ 
    <TopStories key="t" {...videoSliderRest} videos={videos} content={state.article} className={topStoriesClassName} />,
    isCricinfoAsia && videos.length > 0 &&
      <Ad key="gs-ad-m3" id="banner" className="react-ad ad-banner-mobile ad-wrapper" slotType="banner" include={[ 's' ]} kvpos="bottom" isAdBlock={adblock} />
  ]

  if (state.gameState === 'pregame' && commentPreText) {
    commsNts.shift()
  }

  // default columns 'pre' state
  let columnSmall = [
    <SquadTabs key="st" {...state.rosters} />,
    <SquadModule key="s" {...state.rosters} />,
    <MatchDetails key="m" {...state.matchDetails} />
  ]

  let columnB = [
    ...commsNts
  ]

  let columnLarge = [
    <Commentary key="c" {...partCommentary} isPartCommentary={true} showFooter={!updatesOnlyComms} showFilters={false} bet365={state.bet365} editionDomain={editionDomain} gameState={state.gameState} isSmallDevice={state.isSmallDevice}/>,
    commentPreText && 
    <CommentaryFeedback isUpdatesOnly={isUpdatesOnly} key="cfb" gameId={params.gameId} postCommentryFeedback={state.postCommentryFeedback} {...state.commentaryFeedback}/>,
    showBet365module && !isDesktop && <BettingOddsModule key="bo" title="BettingOdds" {...state.bet365} edition={state.edition}/>,
    <PlayersToWatch key="p" roles={state.playersToWatch} />,
    <HeadToHead key="h" {...state.headToHead} sport="cricket" isWebView={state.isWebView} />
  ]

  switch(state.gameState) {
    case 'live':
      columnSmall = [
        !state.isMobile && scoringSourceFeedback && <Statistics key="s" {...state.statistics} showFooter={true} gameState={state.gameState} />,
        !bowlingStarted && <SquadTabs key="st" {...state.rosters} />,
        !bowlingStarted && <SquadModule key="s" {...state.rosters} />,
        <MatchDetails key="m" {...state.matchDetails} />,
        showBet365module && !isDesktop && <BettingOddsModule key="bo" title="BettingOdds" {...state.bet365} edition={state.edition}/>
      ]
      columnB = [
        <InningsSummary key="i" {...state.innings} isSmallDevice={state.isSmallDevice} updateDeviceType={updateDeviceType(state.dispatch)} isWebView={state.isWebView} isLimitedOvers={isLimitedOvers} bet365={state.bet365} editionDomain={editionDomain} groundTime={groundTime} />,
        isDesktop &&
        <GameBreak key="gb" gamebreak={state.ads.gamebreak} gamestatus={state.gameStateClass} gamebreakstatus={state.gameBreakStatus} params={params} query={query} />,
        !isDesktop && <TopStories key="t" {...videoSliderRest} videos={videoSlider.highlightVideos} showFooter={true} title="Video highlights" className={topStoriesClassName} />,
        isCricinfoAsia && activePlayer.length > 0 &&
          <Ad key="gs-ad-3" id="banner" className="react-ad ad-banner-mobile ad-wrapper" slotType="banner" include={[ 's' ]} kvpos="bottom" isAdBlock={adblock} />
      ]
      columnLarge = [
        <Commentary key="c" {...state.partCommentary} showFooter={!updatesOnlyComms} showFilters={false} isPartCommentary={true} isWebView={state.isWebView} isLimitedOvers={isLimitedOvers} bet365={state.bet365} editionDomain={editionDomain} gameState={state.gameState} isSmallDevice={state.isSmallDevice}/>,
        <CommentaryFeedback isUpdatesOnly={isUpdatesOnly} key="cfb" gameId={params.gameId} postCommentryFeedback={state.postCommentryFeedback} {...state.commentaryFeedback}/>
      ]
      break

    case 'final':
      columnSmall = [
        !state.isMobile && scoringSourceFeedback && <Statistics titles={{ batsmen: 'Best performances - Batsmen', bowlers: 'Best performances - Bowlers' }} key="s" {...state.statistics} showFooter={true} />,
        <MatchDetails key="m" {...state.matchDetails} />
      ]
      columnB = [
        <TopStories key="t" {...videoSliderRest} videos={videos} content={state.article} className={topStoriesClassName} />,
        isCricinfoAsia &&
          <Ad key="gs-ad-1" id="banner" className="react-ad ad-banner-mobile ad-wrapper" slotType="banner" include={[ 's' ]} kvpos="bottom" isAdBlock={adblock} />
      ]
      columnLarge = [
        <ScorecardSummary key="ss" {...state.scorecardSummary} isLimitedOvers={isLimitedOvers} />,
        !isUpdatesOnly && <Commentary key="c" gameState={state.gameState} {...state.partCommentary} showFooter={true} showFilters={false} isPartCommentary={true} isWebView={state.isWebView} isLimitedOvers={isLimitedOvers} bet365={state.bet365} editionDomain={editionDomain}/>
      ]
      break
  }

  /*

    Description for each game state id
    1 | won
    2 | lost
    3 | match tied
    4 | match drawn
    5 | no result
    6 | match abandoned without a ball bowled
    7 | match cancelled without a ball bowled

    'Drinks' => 100,
    'Match delayed by rain' => 101,
    'Match delayed by a wet outfield' => 102,
    'Innings break' => 103,
    'Match delayed by bad light' => 104,
    'Match delayed by a wet pitch' => 105,
    'Lunch' => 106,
    'Match delayed by bad weather' => 107,
    'Match delayed by a floodlight failure' => 108,
    'Tea' => 109,
    'Dinner' => 110,
    'Match delayed' => 111,
    'Stumps' => 112

  */

  // If match is abandoned, show squads
  if(stateTypeId === 6) {
    columnSmall.unshift(<SquadTabs key="sq" {...state.rosters} />)
  }


  //ground time only for Pre match
  let printGroundTime = ''
  if(state.gameState === 'pregame' && groundTime) {
    printGroundTime = `<span>Ground time: ${groundTime}</span>`
  }
  const innerWrapperFooter = [
    mobileIncontentAd ,
    <Outbrain key="ob" {...state.outbrainSettings} url={state.pageURL} />
  ]
  let innerWrapper = [
    <div className="inner-wrapper">
      <header className="inner-header bordered">
        {<h1 dangerouslySetInnerHTML={{ __html : `Match Centre ${printGroundTime}` }}></h1> }
        
        {(scorer || commentator) && state.gameState !== 'final' && !state.isMobile &&
          <Scorers scorer={scorer} commentator={commentator}/> || null
        }
      </header>
      <div className="inner-content">
        {
          <div className="col-small inner">
            {columnSmall}
          </div>
        }
        <div className="col-large inner">
          {columnLarge}
        </div>
        {innerWrapperFooter}
      </div>
    </div>
  ]
  const squadsAvailable = selectn('rosters.isAvailable', state)
  const headToHeadAvailable = selectn('headToHead.isAvailable', state)
  const playersToWatchAvailable = selectn('playersToWatch.isAvailable', state)
  const scorecardSummaryAvailable = selectn('scorecardSummary.isAvailable', state)
  const statisticsAvailable = selectn('statistics.enabled', state)
  const preGameModules =  (state.gameState === 'pregame' && !squadsAvailable && !headToHeadAvailable && !playersToWatchAvailable && !isCommentaryAvailable) || false
  const liveGameModules = (state.gameState === 'live' && !statisticsAvailable && !isCommentaryAvailable) || false
  const postGameModules = (state.gameState === 'final' && !scorecardSummaryAvailable && !statisticsAvailable && !isCommentaryAvailable) || false
  // show bronze layout if no modules available in match center
  const showBronzeLayout = preGameModules || liveGameModules || postGameModules
  if(showBronzeLayout) {
    innerWrapper = [
      <MatchDetails key="m" {...state.matchDetails} />,
      ...innerWrapperFooter
    ]
  }
  return (
    <div key="bc" className="layout-bc">
      <div className="col-b">
        {gameheader}
        {mobileAdPlaceholder}
        {columnB}
        {innerWrapper}
      </div>
      {
        !state.isMobile &&
          <div className="col-c">
            {columnThree}
          </div>
      }
    </div>
  )
}

const getScorecard = ({ state, columnThree, isCricinfoAsia, gameheader, mobileAdPlaceholder, mobileIncontentAd }) => {
  return (
    <div key="bc" className="layout-bc">
      <div className="col-b">
        {gameheader}
        {mobileAdPlaceholder}
        <Innings key="im" {...state.scorecard} isWebView={state.isWebView} isSmallDevice={state.isSmallDevice} rosters={state.rosters} gameState={state.gameStateActual} />
        {
          isCricinfoAsia &&
          <Ad key="gs-ad-3" id="banner" className="react-ad ad-banner-mobile ad-wrapper" slotType="banner" include={[ 's' ]} kvpos="bottom" isAdBlock={state.adblock} />
        }
        <MatchDetails key="md" {...state.matchDetails} />
        <CloseOfPlay { ...state.closeOfPlay } />
        <MatchNotes { ...state.noteGroups } />
        { mobileIncontentAd }
        <Outbrain {...state.outbrainSettings} url={state.pageURL} />
      </div>
      {
        !state.isMobile &&
          <div className="col-c">
            {columnThree}
          </div>
      }
    </div>
  )
}

const getCommentary = ({ state, columnThree, showFilters, params, isCricinfoAsia, gameheader, mobileAdPlaceholder, editionDomain, mobileIncontentAd }) => {
  const isLimitedOvers = selectn('matchFlags.limitedOvers', state)

  let contentArea = [
    <Commentary key="c"
      {...state.fullCommentary}
      showFilters={showFilters}
      cmtryInns={state.cmtryInns}
      selInnings={state.selInnings}
      cmtryFilter={state.cmtryFilter}
      selFilter={state.selCmtryFilter && state.selCmtryFilter.text}
      updateMoreCommentary={updateMoreCommentary(state.edition, params, state.location, state.dispatch, state.appProps)}
      isWebView={state.isWebView}
      routerPush={state.routerPush}
      bet365={state.bet365}
      isLimitedOvers={isLimitedOvers}
      editionDomain={editionDomain} />
  ]
  {
    isCricinfoAsia &&
    contentArea.push(<Ad key="gs-ad-3" id="banner" className="react-ad ad-banner-mobile ad-wrapper" slotType="banner" include={[ 's' ]} kvpos="bottom" isAdBlock={state.adblock} />)
  }
  contentArea.push( mobileIncontentAd )
  // Append outbrain for only connectionspeed 'full' in all commentary filters except full commentary
  if (selectn('selCmtryFilter.playtype', state) !== 'full' && selectn('siteType', state) === 'full') {
    
    contentArea.push(<Outbrain key="ob" {...state.outbrainSettings} url={state.pageURL} />)
  }
  return (
    <div key="bc" className="layout-bc gamepackage-commentary">
      <div className="col-b">
        {gameheader}
        {mobileAdPlaceholder}
        {contentArea}
      </div>
      {
        !state.isMobile &&
          <div className="col-c">
            {columnThree}
          </div>
      }
    </div>
  )
}

const getStatistics = ({ state, columnThree, isCricinfoAsia, gameheader, mobileAdPlaceholder, mobileIncontentAd }) => {
  const statistics = state.statistics || {}
  const gameStrip = state.gameStrip || {}
  const scoringSourceFeedback = selectn('scoringSource.isFeedback', state)
  const bestPerformersStats = [
    <BestPerformers title={statistics.bestPerformersBatTitle} type="batsman" players={statistics.batsmen} />,
    <BestPerformers title={statistics.bestPerformersBowlTitle} type="bowler" players={statistics.bowlers} />
  ]

  return (
    <div key="bc" className="layout-bc gamepackage-stats">
      <div className="col-b">
        {gameheader}
        {mobileAdPlaceholder}
        { scoringSourceFeedback && bestPerformersStats }
        {
          isCricinfoAsia &&
          <Ad key="gs-ad-3" id="banner" className="react-ad ad-banner-mobile ad-wrapper" slotType="banner" include={[ 's' ]} kvpos="bottom" isAdBlock={state.adblock} />
        }
        { scoringSourceFeedback &&
          <Partnerships {...statistics.allPartnerships} teams={gameStrip.teams} uiControls={statistics.uiControls} pshipByInnings={statistics.pshipByInnings} />
        }
        <Charts id="chart" { ...state.comparison } uiControls={statistics.uiControls} teams={gameStrip.teams} />
        { mobileIncontentAd }
        <Outbrain {...state.outbrainSettings} url={state.pageURL} />
      </div>
      {
        !state.isMobile &&
          <div className="col-c">
            {columnThree}
          </div>
      }
    </div>
  )
}

const getMatchCoverage = ({ state, columnThree, gameheader, mobileAdPlaceholder }) => {
  return (
    <div key="bc" className="layout-bc">
      <div className="col-b">
        {gameheader}
        {mobileAdPlaceholder}
        <Coverage matchCoverage={ state.matchCoverage } />
      </div>
      {
        !state.isMobile &&
          <div className="col-c">
            {columnThree}
          </div>
      }
    </div>
  )
}

const getVideos = ({ state, columnThree, params, gameheader, mobileAdPlaceholder }) => {
  const edition = state.edition
  const location = state.location
  return (
    <div key="bc" className="layout-bc">
      <div className="col-b">
        {gameheader}
        {mobileAdPlaceholder}
        <VideoGrid {...state.allVideos} updateMoreVideos={updateMoreVideos(edition, params, location, state.dispatch)} />
      </div>
      {
        !state.isMobile &&
          <div className="col-c">
            {columnThree}
          </div>
      }
    </div>
  )
}
const getHawkEye = ({ state, columnThree, gameheader, mobileAdPlaceholder }) => {
  if(state.isMobile) {
    return
  }
  return (
    <div key="bc" className="layout-bc">
      <div className="col-b">
        {gameheader}
        {mobileAdPlaceholder}
        <HawkEye { ...state.hawkEye } />
      </div>
      <div className="col-c">
        { columnThree }
      </div>
    </div>
  )
}
/**
 * construct a handle function to update the next page commenatary
 * @param  {Object} edition     edition config
 * @param  {Object} params      router params
 * @param  {Object} location    router location
 * @param  {Function} dispatch  Store dispatcher function
 * @param  {Object} appProps appProps
 * @return {Function}           hanlder function
 */
const updateMoreCommentary = (edition, params, location, dispatch, appProps) => {
  return (page) => {
    dispatch(
      getPlayByPlayMore({ edition, params, location, page, appProps })
    )
  }
}

const updateMoreVideos = (edition, params, location, dispatch) => {
  return (nextPage, ...rest) => {
    dispatch(
      getVideosMore({ edition, params, location, nextPage, ...rest })
    )
  }
}

/**
 * update the devive type
 * @param  {Function} dispatch Store dispatcher function
 * @return {Function}          hanlder function on window resize
 */
const updateDeviceType = (dispatch) => {
  return (width) => {
    dispatch(
      setDeviceType(width)
    )
  }
}

export default getCricketView



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/getAppView.js